export default __webpack_public_path__ + "static/vision05-8125688583a04f48716a130540ac8f6a.jpg";